import { applyMiddleware, combineReducers, compose, createStore as _createStore, Reducer, StoreEnhancer } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IReduxStore } from '../../types/redux';
import { createSimpleReducer } from './createSimpleReducer';
import { BUILDER_CARD_DEFAULT } from '../../constants/builder';
import { USER_DEFAULT } from '../../constants/user';
import { LAYOUT_DEFAULT } from '../../constants/layout';

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers: Reducer<IApplicationState> = combineReducers({
    builderCard: createSimpleReducer(BUILDER_CARD_DEFAULT),
    user: createSimpleReducer(USER_DEFAULT),
    layout: createSimpleReducer(LAYOUT_DEFAULT),
    location: createSimpleReducer<IApplicationState['location']>(null),
    breadcrumbs: createSimpleReducer<IApplicationState['breadcrumbs']>(initialState.breadcrumbs),
    showCallbackButton: createSimpleReducer(true),
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context))) as unknown as StoreEnhancer;

  const createStore = (): IReduxStore => _createStore(reducers, initialState, storeEnchancers) as IReduxStore;

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
